import { useQuery } from '@tanstack/react-query'
import { pipelineStagesApi } from '../api/endpoints'

export interface PipelineStage {
  id: number
  slug: string
  label: string
  color?: string
  position: number
  is_active: boolean
  is_terminal?: boolean
  counts_as_engaged?: boolean
}

export interface ScoringSegment {
  segment: string
  label: string
  min_score: number
  color?: string
}

export function usePipelineStages(product = 'default') {
  const { data } = useQuery({
    queryKey: ['pipeline-stages', product],
    queryFn: () => pipelineStagesApi.list(product),
    staleTime: 5 * 60 * 1000,
  })
  return (data?.data || []) as PipelineStage[]
}

export function useScoringSegments() {
  const { data } = useQuery({
    queryKey: ['scoring-segments'],
    queryFn: async () => {
      const { scoringConfigApi } = await import('../api/endpoints')
      const resp = await scoringConfigApi.getActive()
      const config = resp?.data?.config
      const parsed = typeof config === 'string' ? JSON.parse(config) : config
      return (parsed?.thresholds || []) as ScoringSegment[]
    },
    staleTime: 5 * 60 * 1000,
  })
  return data || []
}
